import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import routeConfiguration from '../../../../routeConfiguration';
import { petrol } from '../../../../styles/mui/colors';
import useScreenSize from '../../../../util/hooks/useScreenSize';
import { createResourceLocatorString } from '../../../../util/routes';
import IconUser from '../../../Icons/IconUser';
import NamedLink from '../../../Links/NamedLink/NamedLink';

const NoBookmarksRegisterCTAComponent = () => {
  const intl = useIntl();
  const theme = useTheme();
  const navigate = useNavigate();

  const { isMobile } = useScreenSize();

  const handleButtonClick = useCallback(() => {
    navigate(
      createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}, intl.locale)
    );
  }, [navigate, intl.locale]);

  return (
    <Stack alignItems="center" spacing={2} sx={{ maxWidth: 'sm', width: '100%', mx: 2 }}>
      <Chip label="BOOKMARKS" />

      <Typography variant="h1">
        <FormattedMessage id="TopbarDesktop.bookmarkLink" />
      </Typography>

      <FavoriteBorderOutlinedIcon sx={{ color: petrol.alpha8, fontSize: '16em' }} />

      <Typography textAlign="center" variant="body1">
        <FormattedMessage id="BookmarkPage.ctaSubheading" />
      </Typography>

      <Button
        color="primary"
        fullWidth={isMobile}
        onClick={handleButtonClick}
        startIcon={<IconUser />}
        variant="contained"
      >
        <FormattedMessage id="SectionBecomeHost.encourageSignup" />
      </Button>

      <Typography sx={{ display: 'inline' }}>
        <FormattedMessage id="BookmarkPage.loginCTA" />
        <NamedLink
          name="SigninPage"
          style={{ underline: 'none', marginLeft: '0.5em', color: theme.palette.primary.main }}
        >
          <FormattedMessage id="BookmarkPage.loginLink" />
        </NamedLink>
      </Typography>
    </Stack>
  );
};

NoBookmarksRegisterCTAComponent.displayName = 'NoBookmarksRegisterCTAComponent';
const NoBookmarksRegisterCTA = memo(NoBookmarksRegisterCTAComponent);

export default NoBookmarksRegisterCTA;
